import { Chip, Theme } from '@mui/material'
import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

export const ComingSoonChip = (): JSX.Element => {
  const { t } = useTranslation('features/product', {
    keyPrefix: 'label.title',
  })

  return (
    <Chip
      label={t('comingSoon')}
      size='small'
      sx={({ palette }: Theme): CSSProperties => ({
        backgroundColor: palette.background.default,
        color: palette.purple.main,
      })}
    />
  )
}
